import React from 'react';

import { useTranslation } from 'react-i18next';
import { UserRole } from '../../../../../OrdersPage/types';
import * as Styled from './PaymentIndicator.styles';

interface PaymentIndicatorProps {
  paid: boolean;
  role: UserRole;
}

const PaymentIndicator = ({ paid, role }: PaymentIndicatorProps) => {
  const { t } = useTranslation();

  if (
    ![
      UserRole.PHARMACIST,
      UserRole.MANAGER,
      UserRole.PHARMACY_MANAGER,
    ].includes(role)
  ) {
    return null;
  }

  return (
    <Styled.PaymentIndicatorContainer>
      <div className={`indicator ${paid ? 'paid' : 'not-paid'}`}>
        {t(`OrdersPage.${paid ? 'INDICATOR_PAID' : 'INDICATOR_NOT_PAID'}`)}
      </div>
    </Styled.PaymentIndicatorContainer>
  );
};

export default PaymentIndicator;
